<template>
  <div id="playground">
    <i-total-calendar
      :mode="calendarMode"
      :date-click="(e)=>onDayClick(e,'week')"
      :highlight="highlight"
      @titleClick="handleTitleClick"
      @next="onDayClick"
      @prev="onDayClick"
    ></i-total-calendar>
    <div v-if="calendarMode === 'week'">
      <section v-if="isShopmanager">
        <v-toolbar
          elevation="0"
          class="header-toolbar"
        >
          <v-toolbar-title>
            <v-btn
              :plain="tab != 'coach'"
              color="primary"
              @click="tab = 'coach'"
            >
              Coach
            </v-btn>
          </v-toolbar-title>
          <v-toolbar-title>
            <v-btn
              :plain="tab != 'center'"
              color="primary"
              class="ml-2"
              @click="tab = 'center'"
            >
              Center
            </v-btn>
          </v-toolbar-title>
          <v-toolbar-title>
            <v-btn
              plain
              color="primary"
              class="ml-2"
              @click="refresh()"
            >
              <v-icon>
                mdi-refresh
              </v-icon>
            </v-btn>
          </v-toolbar-title>
        </v-toolbar>
        <!-- <v-tabs
          v-model="tab"
          hide-slider
        >
          <v-tab href="#coach">
            Coach
          </v-tab>

          <v-tab href="#center">
            Center
          </v-tab>
        </v-tabs> -->
        <section v-if="tab === 'coach'">
          <swipe-list
            v-if="bookingList.length>0"
            ref="swipeListRef"
            class="scroll-list"
            :style="{ maxHeight: nodeHeight }"
            :items="bookingList"
          >
            <template v-slot="{ item, index, revealLeft, revealRight, close }">
              <coach-booking-item
                :item="item"
                :index="index"
                @click="handleRowClick(item,index)"
              ></coach-booking-item>
            </template>
            <template v-slot:right="{ item }">
              <div
                v-if="qrcodeChecking(item)"
                class="swipeout-action deep-sky-blue"
                @click="handleQrcode(item)"
              >
                <v-icon
                  large
                  color="white"
                >
                  mdi-qrcode
                </v-icon>
              </div>
              <div
                v-if="dateAfterChecking(item)"
                class="swipeout-action dark-turquoise"
                @click="handleTransfer(item)"
              >
                <v-icon
                  large
                  color="white"
                >
                  mdi-swap-horizontal
                </v-icon>
              </div>
            </template>
          </swipe-list>
          <v-card
            v-if="bookingList.length==0"
            class="card-content"
          >
            <v-list-item>
              <v-list-item-content>
                list is empty ( filtered or just empty )
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </section>
        <section v-if="tab === 'center'">
          <v-card>
            <div class="pt-2 d-flex pb-2 px-2">
              <span class="center-filter">
                <universal-input
                  v-model="centerFilter"
                  :config="centerFilterConfig"
                >
                </universal-input>
              </span>
              <span>
                <universal-input
                  v-model="courseStartFilter"
                  :config="courseStartFilterConfig"
                >
                </universal-input>
              </span>
            </div>
            <swipe-list
              v-if="centerBookingList.length>0"
              ref="swipeListRef"
              class="scroll-list"
              :style="{ maxHeight: nodeHeight }"
              :items="centerBookingList"
            >
              <template v-slot="{ item, index, revealLeft, revealRight, close }">
                <coach-booking-item
                  :item="item"
                  :index="index"
                  :show-coach="true"
                  @click="handleRowClick(item,index)"
                ></coach-booking-item>
              </template>
              <template v-slot:right="{ item }">
                <div
                  v-if="dateAfterChecking(item)"
                  class="swipeout-action deep-sky-blue"
                  @click="handleQrcode(item)"
                >
                  <v-icon
                    large
                    color="white"
                  >
                    mdi-qrcode
                  </v-icon>
                </div>
                <div
                  v-if="dateAfterChecking(item)"
                  class="swipeout-action dark-turquoise"
                  @click="handleTransfer(item)"
                >
                  <v-icon
                    large
                    color="white"
                  >
                    mdi-swap-horizontal
                  </v-icon>
                </div>
                <div
                  class="swipeout-action green-yellow"
                  @click="handleAbnormal(item)"
                >
                  <v-icon
                    large
                    color="white"
                  >
                    mdi-account-clock
                  </v-icon>
                </div>
              </template>
            </swipe-list>
            <v-card
              v-if="centerBookingList.length==0"
              class="card-content"
            >
              <v-list-item>
                <v-list-item-content>
                  list is empty ( filtered or just empty )
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-card>
        </section>
      </section>
      <section v-else>
        <swipe-list
          v-if="bookingList.length>0"
          ref="swipeListRef"
          class="scroll-list"
          :style="{ maxHeight: nodeHeight }"
          :items="bookingList"
        >
          <template v-slot="{ item, index, revealLeft, revealRight, close }">
            <div class="card-content">
              <v-list-item @click="handleRowClick(item,index)">
                <v-list-item-avatar
                  size="large"
                  rounded
                  color="#a8a8a8"
                >
                  <v-list-item-content class="time-span">
                    <div>{{ formatTime(item.courseStartTime) }}</div>
                    <div>~</div>
                    <div>{{ formatTime(item.courseEndTime) }}</div>
                  </v-list-item-content>
                </v-list-item-avatar>
                <div>
                  <div> Course: {{ `${item.course.courseCode} ${item.course.courseName}` }} </div>
                  <div> Student: {{ item.userRecord.fullName }} </div>
                  <div> Center: {{ item.center.description }} </div>
                </div>
              </v-list-item>
            </div>
          </template>
          <template v-slot:right="{ item }">
            <div
              v-if="qrcodeChecking(item)"
              class="swipeout-action deep-sky-blue"
              @click="handleQrcode(item)"
            >
              <v-icon
                large
                color="white"
              >
                mdi-qrcode
              </v-icon>
            </div>
            <div
              v-if="dateAfterChecking(item)"
              class="swipeout-action dark-turquoise"
              @click="handleTransfer(item)"
            >
              <v-icon
                large
                color="white"
              >
                mdi-swap-horizontal
              </v-icon>
            </div>
            <div
              class="swipeout-action green-yellow"
              @click="handleAbnormal(item)"
            >
              <v-icon
                large
                color="white"
              >
                mdi-account-clock
              </v-icon>
            </div>
          </template>
        </swipe-list>
        <v-card
          v-if="bookingList.length==0"
          class="card-content"
        >
          <v-list-item>
            <v-list-item-content>
              list is empty ( filtered or just empty )
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </section>
    </div>
    <v-dialog
      v-model="createBookingDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ createBookingTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="handleCreateBooking"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <create-booking
            ref="createBookingInfo"
            :selected-day="selectedDay"
            :create-booking-dialog="createBookingDialog"
            :center-i-d="centerFilter"
            :tab="tab"
          >
          </create-booking>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="transferBookingDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ transferBookingTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              v-if="showTransferBookingSaveButton"
              dark
              text
              @click="handleTransferBooking"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <transfer-booking
            ref="transferBookingRef"
            :booking-info="currentBooking"
          ></transfer-booking>

          <section v-if="bookingTransferList.length>0">
            <h2>Transfer Booking:</h2>
            <vue-horizontal
              scroll
              :button="false"
              class="horizontal"
            >
              <booking-transfer-item
                v-for="bookingTransfer in bookingTransferList"
                :key="bookingTransfer.id"
                :booking-transfer="bookingTransfer"
                @cancel="handleCancelTransfer"
                @loading="loading(true)"
              ></booking-transfer-item>
            </vue-horizontal>
          </section>

          <!-- <accept-transfer-booking></accept-transfer-booking> -->
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="abnormalAttendanceDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ abnormalAttendanceTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="handleAbnormalAttendance"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <abnormal-attendance
            ref="abnormalAttendanceRef"
            :booking-info="currentBooking"
          ></abnormal-attendance>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="bookingInfoDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ bookingInfoTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
          <booking-info-page
            ref="bookingInfoRef"
            :booking-info-prop="currentBooking"
            @canceled="handleCancel"
            @loading="load(true)"
            @open-diary="handleOpenDiary"
          ></booking-info-page>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="qrcodeDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="qrcodeDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ bookingInfoTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
          <course-qrcode
            :booking="currentBooking"
          ></course-qrcode>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar
      ref="snackbar"
      v-model="msgToast"
    >
      {{ message }}
    </v-snackbar>
    <DiaryRecord
      v-model="diaryDialog"
      :booking-info-prop="currentBooking"
      @closed="refresh"
    ></DiaryRecord>
    <v-btn
      v-if="dateChecking && enableCreateBooking && calendarMode === 'week'"
      fab
      elevation="1"
      class="create-booking-btn"
      dark
      absolute
      color="#008800"
      @click="handleCreate"
    >
      <v-icon
        size="36"
        color="white"
      >
        mdi-plus
      </v-icon>
    </v-btn>
  </div>
</template>
<script setup>
import { ref, nextTick, onMounted, computed, watch, onBeforeUnmount } from 'vue'
import VueHorizontal from 'vue-horizontal'
import { callbackify } from 'util'
import { getVuetify } from '@core/utils'
import DiaryRecord from './DiaryRecord.vue'
import moment from '@/utils/moment'
import ITotalCalendar from '@/components/Calendar/ITotalCalendar'
import SwipeList from '@/components/SwipeList/SwipeList'
import { useStore } from '@/store'
import TransferBooking from './BookingCalendar/TransferBooking'
import AcceptTransferBooking from './BookingCalendar/AcceptTransferBooking'
import AbnormalAttendance from './BookingCalendar/AbnormalAttendance'
import CreateBooking from './BookingCalendar/CreateBooking'
import { getUserData } from '@/utils/auth'
import { createItem, fetchList, assignNewCoach,
  listBookingTransfers, updateAbnormalAttendanceReason,
  isAssignedCoach, cancel, listCoachCenter,
  getHighlight,
} from '@/api/bookedCourse'
import BookingTransferItem from './BookingCalendar/components/BookingTransferItem'
import BookingInfoPage from './BookingCalendar/BookingInfoPage'
import CourseQrcode from './BookingCalendar/CourseQrcode'
import { formatTime, hasRole, loading } from '@/utils/helper'

import '@/styles/swipelist.css'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import CoachBookingItem from './BookingCalendar/CoachBookingItem.vue'

const highlight = ref([])

function qrcodeChecking(item) {
  console.log('qrcodeChecking', item)
  console.log(moment(item.courseDate).endOf('day'))
  if (moment().isBefore(moment(item.courseDate).endOf('day'))
    && moment().isAfter(moment(item.courseDate).startOf('day'))
    && item.courseStatusID === 1
  ) {
    return true
  }

  return false
}

// const isLoading = ref(false)
const snackbar = ref(null)

const isShopmanager = ref(false)
const tab = ref('coach')

const swipeListRef = ref(null)

const enableCreateBooking = ref(false)

const store = useStore()

const coachCenterList = ref([])

const selectedDay = ref('')
function refreshHighlight() {
  const postData = {}
  if (selectedDay.value) {
    postData.courseDate = selectedDay.value
  }
  console.log('refreshHighlight', postData)
  getHighlight(postData).then(res => {
    if (res.data.items) {
      highlight.value = res.data.items
    }
  })
}
const centerFilter = ref(-1)
const centerFilterConfig = ref({
  name: 'centerFilter',
  label: 'Center',
  type: {
    name: 'select',
    items: coachCenterList.value,
  },
})
const courseStartFilter = ref(null)
const courseStartFilterConfig = ref({
  name: 'courseStartFilter',
  label: 'Course Start Time',
  type: {
    name: 'timepicker',
  },
})

onMounted(() => {
  isAssignedCoach().then(res => {
    console.log('isAssignedCoach', res)
    if (res.data.record) {
      enableCreateBooking.value = true
    } else {
      enableCreateBooking.value = false
    }
  })
  const roleArr = hasRole([4])
  if (roleArr.length > 0) {
    isShopmanager.value = true
  }

  store.dispatch('course/list', {})
    .then(result => {
      console.log('course result', result)
    })
    .catch(err => {
      console.log('err', err)
    })
  const userData = getUserData()
  console.log('booking user data', userData)
  store.dispatch('center/list', {})
    .then(result => {
      console.log('center result', result)
    })
    .catch(err => {
      console.log('err', err)
    })

  listCoachCenter().then(res => {
    const { items } = res.data
    for (let index = 0; index < items.length; index += 1) {
      const item = items[index]
      if (item.center) {
        if (centerFilter.value === -1) {
          centerFilter.value = item.center.id
        }
        coachCenterList.value.push({
          id: item.center.id,
          label: item.center.description,
        })
      }
    }
    console.log('listCoachCenter', coachCenterList.value)
  })
  selectedDay.value = moment().format('yyyy-MM-DD')
  console.log('selectedDay.value', selectedDay.value)
  courseStartFilter.value = moment(selectedDay.value).startOf('day').add('08:00').format('yyyy-MM-DD HH:mm:ss')
  console.log('courseStartFilter.value', courseStartFilter.value)

  refreshHighlight()
})

const nodeHeight = ref('0px')
const $vuetify = getVuetify()
const isMobile = computed(() => $vuetify.breakpoint.mdAndDown)
function updateNodeHeight() {
  let extraHeight = 0
  if (tab.value === 'coach') {
    extraHeight = 0
    if (isMobile && tab.value === 'coach') {
      extraHeight = 55
    }
  } else {
    extraHeight = 0
    if (isMobile && tab.value === 'center') {
      extraHeight = 125
    }
  }
  const nodeHeightValue = window.innerHeight - 180 - 40 - extraHeight
  console.log('nodeHeightValue', nodeHeightValue)
  nodeHeight.value = `${nodeHeightValue}px`
}
onMounted(() => {
  updateNodeHeight()
  window.addEventListener('resize', updateNodeHeight)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateNodeHeight)
})

const bookingInfoDialog = ref(false)

const bookingList = ref([
])
const centerBookingList = ref([
])

const diaryDialog = ref(false)
function handleOpenDiary() {
  console.log('handleOpenDiary')
  bookingInfoDialog.value = false
  diaryDialog.value = true
}

function dateAfterChecking(item) {
  // console.log('dateAfterChecking', moment(item.courseEndTime))
  // console.log('moment().utc()', moment().utc())
  // console.log('moment(item.courseEndTime).isAfter(moment())', moment(item.courseEndTime).isAfter(moment().utc()))

  return moment(item.courseEndTime).utc().isAfter(moment().utc())
}

const dateChecking = computed(() => {
  if (moment(selectedDay.value).isAfter(moment().startOf('day').add(-1, 'days'))
    && moment(selectedDay.value).isBefore(moment().startOf('day').add(14, 'days'))
  ) {
    return true
  }

  return false
})

const msgToast = ref(false)
const message = ref('')
function showMessage(msg) {
  message.value = msg
  msgToast.value = true
}

const defaultCalendarMode = 'twomonth'
const calendarMode = ref(defaultCalendarMode)
function handleTitleClick() {
  console.log('handleTitleClick', calendarMode.value)
  calendarMode.value = defaultCalendarMode
}

const createBookingDialog = ref(false)
const createBookingTitle = ref('Create Booking')

const createBookingInfo = ref(null)
function fetchBooking(fetchCenterBooking) {
  let fetchCenter = false
  if (fetchCenterBooking) {
    fetchCenter = true
  }

  // console.log('fetchBooking centerFilter.value', centerFilter.value)
  // console.log('fetchBooking courseStartFilter.value', moment(courseStartFilter.value).format('yyyy-MM-DD HH:mm:ss'))
  // console.log('fetchBooking courseStartFilter.value', moment(courseStartFilter.value).utc().format('yyyy-MM-DD HH:mm:ss'))

  return new Promise(resolve => {
    const postData = {
      page: 0,
      limit: 0,
      courseDate: selectedDay.value,
      orderBy: 'CourseStartTime',

      // 1: normal 2: canceled 3: completed
      // fetch normal and completed record, filter canceled records
      courseStatusIDList: ['1', '3'],
      fetchCenter,
    }
    if (centerFilter.value) {
      postData.centerFilter = centerFilter.value
    }
    if (courseStartFilter.value) {
      // because the timezone set to HK, so before send to server, need to convert to UTC
      postData.courseStartFilter = moment(courseStartFilter.value).utc().format('yyyy-MM-DD HH:mm:ss')
    }
    fetchList(postData).then(result => {
      if (result.data) {
        console.log('fetchBooking', result.data.items)
        const { items } = result.data
        if (fetchCenter) {
          centerBookingList.value = items
        } else {
          bookingList.value = items
        }
        resolve(items)
      }
    })
  })
}

watch(centerFilter, newVale => {
  console.log('centerFilter', newVale)
  if (newVale) {
    // isLoading.value = true
    fetchBooking(true).then(res => {

    }).finally(() => {
      // isLoading.value = false
    })
  }
})

watch(courseStartFilter, newVale => {
  console.log('courseStartFilter', newVale)
  if (newVale) {
    // isLoading.value = true
    fetchBooking(true).then(res => {
    }).finally(() => {
      // isLoading.value = false
    })
  }
})
watch(tab, newVale => {
  console.log('tab', newVale)

  // isLoading.value = true
  loading(true)
  const promiseList = [fetchBooking()]
  if (isShopmanager.value) {
    promiseList.push(fetchBooking(true))
  }
  Promise.all(promiseList).then(() => {
  })
    .catch(error => {
      console.log('error', error)
    })
    .finally(() => {
      loading(false)

      // isLoading.value = false
    })

  updateNodeHeight()
})

const abnormalAttendanceDialog = ref(false)
const abnormalAttendanceTitle = 'Abnormal Attendance'

const transferBookingDialog = ref(false)
const transferBookingTitle = 'Transfer Booking'

function handleCreate() {
  console.log('handleCreate')
  createBookingDialog.value = true
}

const currentBooking = ref({
  bookingNo: '',
  userRecord: {
    fullName: '',
  },
  center: {
    description: '',
  },
  courseDate: '',
  courseStartTime: '',
  courseEndTime: '',
})

const bookingInfoTitle = ref('Booking Information')

function handleRowClick(item, index) {
  if (swipeListRef.value.isRevealed === index) {
    swipeListRef.value.close()
  } else {
    currentBooking.value = { ...item }
    bookingInfoDialog.value = true
  }
}
const bookingInfoRef = ref(null)
const transferBookingRef = ref(null)

const bookingTransferList = ref([])

function fetchBookingTransfers() {
  console.log('fetchBookingTransfers currentBooking.id', currentBooking)
  listBookingTransfers({
    id: currentBooking.value.id,
  }).then(response => {
    console.log('listBookingTransfers', response)
    bookingTransferList.value = response.data.items
    loading(false)

    // isLoading.value = false
  })
}

const showTransferBookingSaveButton = computed(() => {
  if (bookingTransferList.value) {
    if (bookingTransferList.value.length !== 0) {
      let showBtn = true
      bookingTransferList.value.forEach(bookingTransfer => {
        if (bookingTransfer.courseStatusID === 1) {
          showBtn = false
        }
      })

      return showBtn
    }

    return true
  }

  return false
})

function handleCancelTransfer() {
  fetchBookingTransfers()
  showMessage('Transfer canceled!')
}

function handleAbnormalAttendance() {
  updateAbnormalAttendanceReason(currentBooking.value).then(response => {
    console.log('updateAbnormalAttendanceReason', response)

    if (response.code === 20000) {
      showMessage('Updated')
    }
  })
}

const abnormalAttendanceRef = ref(null)

function handleCloseDialog() {
  currentBooking.value = {
    bookingNo: '',
    course: {
      courseCode: '',
      courseName: '',
    },
    userRecord: {
      fullName: '',
    },
    center: {
      description: '',
    },
    courseStartTime: '',
    courseEndTime: '',
  }
  if (createBookingInfo.value) {
    createBookingInfo.value.reset()
  }
  if (transferBookingRef.value) {
    transferBookingRef.value.reset()
  }
  if (abnormalAttendanceRef.value) {
    abnormalAttendanceRef.value.reset()
  }
  abnormalAttendanceDialog.value = false
  transferBookingDialog.value = false
  createBookingDialog.value = false
  bookingInfoDialog.value = false

  // diaryDialog.value = false
  refreshHighlight()
  if (swipeListRef.value) {
    swipeListRef.value.close()
  }
}

function fetchBothBooking(callback) {
  const promiseList = [fetchBooking()]
  if (isShopmanager.value) {
    promiseList.push(fetchBooking(true))
  }
  Promise.all(promiseList).then(res => {
    if (callback) {
      callback(res)
    }
  })
    .catch(error => {
      console.log('error', error)
    })
    .finally(() => {
      loading(false)
    })
}

function refresh() {
  loading(true)
  fetchBothBooking(() => {
    loading(false)
  })
}

function handleTransferBooking() {
  const transferData = transferBookingRef.value.getTransferData()
  console.log('transferData', transferData)

  // isLoading.value = true
  loading(true)
  assignNewCoach(transferData).then(response => {
    console.log('handleTransferBooking', response)

    if (response.data && response.data.record) {
      fetchBothBooking(() => {
        showMessage('Notification sent to target coach. Waiting for accept.')
        handleCloseDialog()
      })
    }
  }).catch(e => {
    console.log('e', e)
  }).finally(() => {
    // isLoading.value = false
    loading(false)
  })
}

function handleCancel() {
  loading(true)
  fetchBothBooking(() => {
    showMessage('Booking canceled!')
    handleCloseDialog()
  })
}

function handleCreateBooking() {
  console.log('createBookingInfo.value.bookingInfo', createBookingInfo.value.bookingInfo)

  // isLoading.value = true
  loading(true)
  createItem(createBookingInfo.value.bookingInfo).then(response => {
    console.log('create response', response)
    if (response.code === 20000) {
      fetchBothBooking(() => {
        showMessage('Booking created.')
        handleCloseDialog()
      })
    }
  }).catch(error => {
    // isLoading.value = false
    console.log('error', error)

    // handleCloseDialog()
  }).finally(() => {
    // isLoading.value = false
    loading(false)
  })
}

const qrcodeDialog = ref(null)
function handleQrcode(item) {
  console.log('handleQrcode', item)
  currentBooking.value = item
  qrcodeDialog.value = true
}
function handleTransfer(item) {
  transferBookingDialog.value = true
  console.log('handleTransfer', item)
  currentBooking.value = item

  // fetch bookingTransfer record
  fetchBookingTransfers()
}
function handleAbnormal(item) {
  abnormalAttendanceDialog.value = true
  console.log('handleAbnormal', item)
  currentBooking.value = item
}

const studentList = ref([])

const enabled = ref(true)

const selectedOpen = ref(false)

function onDayClick(day, mode) {
  console.log(day)
  selectedDay.value = day.date
  console.log('selectedDay.value', selectedDay.value)
  courseStartFilter.value = moment(selectedDay.value).startOf('day').add('08:00').format('yyyy-MM-DD HH:mm:ss')

  if (mode) {
    calendarMode.value = 'week'
  }

  if (calendarMode.value === 'week') {
    // showEvent()
    // isLoading.value = true
    loading(true)

    // fetchBooking().then(response => {
    //   isLoading.value = false
    // })
    // const promiseList = [fetchBooking()]
    // if (isShopmanager.value) {
    //   promiseList.push(fetchBooking(true))
    // }
    // Promise.all(promiseList).then(responseResult => {
    //   // showMessage('Booking created.')
    //   // handleCloseDialog()
    // })
    //   .catch(error => {
    //     console.log('error', error)
    //   })
    //   .finally(() => {
    //     // isLoading.value = false
    //     loading(false)
    //   })

    fetchBothBooking()
  } else {
    refreshHighlight()
  }
}
</script>
<style scoped>

.time-span {
  color: white
}
.horizontal >>> .v-hl-container {
  /* Space between content and scrollbar */
  /* padding-bottom: 16px; */

  /* For firefox only */
  scrollbar-width: thin;
  /* scrollbar-color: orangered black; */
}

.horizontal >>> .v-hl-container::-webkit-scrollbar {
  height: 0px;
  width: 16px;
  background: transparent;
}
.scroll-list{
  overflow-y: scroll;

  scrollbar-width: thin;
}
.scroll-list::-webkit-scrollbar {
  width: 0px;
  background: transparent;
  /* background-color: DeepSkyBlue; */
}
.scroll-list::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background: #b0b0b0;
  border: solid 0px #e6e6e6;
}
.create-booking-btn-mobile{
  bottom: -28px;
  right:50px
}
.create-booking-btn{
  bottom: 30px;
  right:50px
}
.center-filter{
  max-width: 170px;
}
.header-toolbar{
  border: 1px solid;
    border-top-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 1px;
    border-left-width: 1px;
    border-top-style: solid;
    border-right-style: solid;
    border-bottom-style: solid;
    border-left-style: solid;
    border-color: #cbd5e0;
}

.swipeout-list-item{
  min-height: 110px;
}
</style>
